const twinsBabyCongratsData = {
    0: {
      subtext: "[0~2주차] 새 생명의 시작, 함께 시작하는 여정\n\n👩🏻엄마의 몸은 착상을 위한 호르몬 변화로 감기같은 증상이 느껴질 수 있어요. 엽산과 비타민D 같은 필수 영양소도 미리 챙기면 좋아요.\n\n👨🏻아빠도 건강한 정자 준비를 시작할 때랍니다.\n\n함께 만드는 생명의 첫걸음, 지금부터 천천히 준비해요."
    },
    1: {
      subtext: "[0~2주차] 새 생명의 시작, 함께 시작하는 여정\n\n👩🏻엄마의 몸은 착상을 위한 호르몬 변화로 감기같은 증상이 느껴질 수 있어요. 엽산과 비타민D 같은 필수 영양소도 미리 챙기면 좋아요.\n\n👨🏻아빠도 건강한 정자 준비를 시작할 때랍니다.\n\n함께 만드는 생명의 첫걸음, 지금부터 천천히 준비해요."
    },
    2: {
      subtext: "[0~2주차] 새 생명의 시작, 함께 시작하는 여정\n\n👩🏻엄마의 몸은 착상을 위한 호르몬 변화로 감기같은 증상이 느껴질 수 있어요. 엽산과 비타민D 같은 필수 영양소도 미리 챙기면 좋아요.\n\n👨🏻아빠도 건강한 정자 준비를 시작할 때랍니다.\n\n함께 만드는 생명의 첫걸음, 지금부터 천천히 준비해요."
    },
    3: {
      subtext: "[3주차] 조용히 착상 중, 두 생명이 자리 잡아요\n\n👶🏻쌍둥이 배아는 자궁에 착상하며 각자의 리듬으로 성장 중이에요.\n\n👩🏻엄마는 피로, 이른 입덧, 유방통, 감정 기복 등 초기 증상이 더 뚜렷할 수 있어요. 엽산·단백질·철분·칼슘을 충분히 챙기세요.\n\n👨🏻아빠는 금연·금주, 따뜻한 말 한마디로 아내의 변화에 함께 반응해주세요."
    },
    4: {
      subtext: "[4주차] 두 생명의 기관 형성기, 조심히 시작해요.\n\n착상이 완료되며 두 아기의 심장·뇌·신경이 자라기 시작해요.\n\n엄마는 피로·입덧·잦은 소변을 경험할 수 있어요.지금은 약물·X선·흡연 모두 조심할 시기랍니다.\n\n병원 선택은 거리·시설·의료진 꼼꼼히 확인하고, 아빠는 첫 초음파에 꼭 동행해주세요.🍀"
    },
    5: {
      subtext: "[5주차] 두 생명을 위한 5주차 시작!\n\n입덧, 감정 기복, 피로감이 단태아보다 강하게 나타날 수 있어요.\n\n💊임신 사실을 몰랐던 약 복용은 대부분 큰 문제가 되지 않지만, 걱정된다면 병원 상담이 우선이에요.\n\n쌍둥이 임신은 작은 무리도 민감하게 작용할 수 있으니 오늘 하루는 조금 더 천천히, 다정하게 보내세요.😊"
    },
    6: {
      subtext: "[6주차] 두 개의 작은 심장이 힘차게 뛰기 시작했어요!\n\n입덧·빈뇨·기분 기복 등 호르몬 변화로 몸과 마음이 요동치는 시기예요.😣 물을 자주 마시고, 감정 변화엔 스스로에게 너그러이 대해주세요.\n\n아빠는 병원 일정을 미리 확인하고 진료에 꼭 동행해 주세요.\n\n짧은 말 한마디, 따뜻한 손길이 아내에게 큰 위로가 된답니다.😘"
    },
    7: {
      subtext: "[7주차] 두 아이를 위한 변화가 더 뚜렷해졌어요!\n\n입덧이 심해지고, 기운도 쭉 빠질 수 있습니다. 무리하지 말고, 두 생명을 위한 하루하루를 보내세요. 물과 간식은 조금씩 자주 드세요.\n\n아빠는 집안일을 분담하고, 냄새 나는 음식물 처리는 꼭 맡아주세요!☺"
    },
    8: {
      subtext: "[8주차] 자궁도 커지고, 아기도 빠르게 성장 중이에요!\n\n입덧, 분비물, 팽창감… 몸의 변화가 분명해져요.\n\n분비물 증가는 정상! 하지만 냄새·가려움이 심하면 병원에 꼭 방문하시고 수분과 영양 섭취를 잘 챙기세요.\n\n아빠는 집안일, 병원 일정, 감정 살피기까지 함께하는 임신가정의 동반자예요.🤗"
    },
    9: {
      subtext: "[9주차] 쉽게 짜증나고 피로해져요.\n\n쌍둥이로 인한 호르몬 변화로 감정기복과 피로가 커져요. 무리하지 말고 자주 쉬어주세요.\n\n아빠는 \"왜 그래?\"보다 \"괜찮아?\"로 다가와 주세요.\n함께 걱정하고 나누는 말 한마디가 아내에게 큰 힘이 됩니다.💕"
    },
    10: {
      subtext: "[10주차] 입덧 최고조, 조금만 더 힘내요!\n\n입덧은 곧 잦아들어요. 지금은 물을 자주 마시고, 먹고 싶은 음식만 조금씩 자주 섭취해요.\n아랫배 통증과 늘어난 핏줄은 자연스러운 변화랍니다.\n\n아빠는 국민행복카드 신청 등 의료비 지원도 함께 챙겨주세요."
    },
    11: {
      subtext: "[11주차] 엄마의 혈액량이 늘었어요!\n\n자궁이 커지며 혈류도 증가해 어지럼증이나 빈혈이 나타날 수 있어요. 철분이 풍부한 음식과 보충제를 꼭 챙기세요.\n\n질 분비물 증가도 자연스러운 변화예요. 통풍 잘 되는 옷과 위생 관리로 불편함을 줄여보세요.🎈"
    },
    12: {
      subtext: "[12주차] 자궁이 자몽만큼 커졌어요!\n\n자궁이 골반 밖으로 나와 아랫배가 살짝 볼록해졌어요. 방광 압박으로 소변이 잦고, 인대가 당기며 아랫배 통증도 생겨요.\n\n1차 기형아 검사 시기예요. 검사는 간단하니 편한 마음으로 받아보세요.\n\n👨🏻아빠의 따뜻한 격려 한마디가 아내에게 큰 힘이 돼요!"
    },
    13: {
      subtext: "[13주차] 입덧이 줄고 식욕이 돌아와요!\n\n입덧은 차츰 가라앉고 식욕이 돌아오는 시기예요. 쌍둥이를 위한 균형 잡힌 식사와 체중 관리가 중요해요.\n\n아내의 입맛을 배려하면서도 과식은 피할 수 있도록 아빠가 식사 페이스메이커가 되어주세요. 함께하는 건강한 식탁이 두 아이에게 최고의 선물이 될 거예요.💗"
    },
    14: {
      subtext: "[14주] 배가 점점 불러오고 있어요, 새로운 전환점!\n\n쌍둥이를 품은 몸은 더 빠르게 변화해요. 아랫배가 나오고 피부 트러블이 생기기도 하죠. 이 시기엔 영양소를 고루 챙기고, 튼살도 미리 관리해 주세요.\n\n완성된 태반을 통해 두 아기는 엄마와 본격적으로 연결되었답니다.\n\n아빠는 마사지를 통해 아내와 두 아기에게 따뜻한 마음도 함께 전해보세요.☺️"
    },
    15: {
      subtext: "[15주차] 몸과 마음이 모두 변화하는 시기, 함께 준비해요!\n\n복부가 도드라지고 체중도 늘며 쌍둥이의 성장이 눈에 보여요. 기초체온은 낮아지고 잇몸은 약해지기 쉬우니 구강 관리도 신경 써주세요.\n\n초음파에선 꼼지락거리는 두 아이의 움직임이 또렷이 보여요. 성별은 자세에 따라 안 보일 수도 있답니다. 😚"
    },
    16: {
      subtext: "[16주차] 안정기, 그래도 조심! 두 아기는 계속 자라고 있어요.\n\n배가 눈에 띄게 불러오고 허리에 부담이 느껴질 수 있어요. 바른 자세를 유지하고 스트레칭을 해주세요.\n\n성관계는 가능하지만 배를 누르지 말고 콘돔 사용과 위생을 꼭 지켜주세요. 배려하는 마음이 가족을 더 가깝게 해줘요.🤗"
    },
    17: {
      subtext: "[17주차] 조심스레 느껴지는 태동, 작은 기적의 시작이에요.\n\n🫧물이 뽀글거리는 느낌, 장이 꾸르륵하는 느낌이 있다면 첫 태동일 수 있어요. 식욕이 돌아오며 체중이 급격히 늘 수 있어요. 철분과 섬유소를 챙기고, 변비 예방도 잊지 마세요.\n\n검사 일정 많아지는 시기, 배우자의 세심한 배려가 큰 힘이 됩니다.🌹"
    },
    18: {
      subtext: "[18주차] 태동이 느껴지기 시작했어요!\n\n두 아기의 움직임이 점점 뚜렷해져요.\n\n질 분비물과 유방 변화는 자연스러운 증상이지만, 악취·가려움이 있으면 진료가 필요합니다.\n\n아빠 목소리는 아기에게 닿는 가장 따뜻한 음악이에요. 지금부터 아기들에게 말을 걸어보세요. 태명으로 불러주면 더 좋아요!🐥"
    },
    19: {
      subtext: "[19주차] 두 아이를 위한 변화, 몸도 마음도 적응 중이에요.\n\n유륜이 짙어지고 유즙이 나올 수 있어요. 쌍둥이로 인한 체중 증가로 코골이나 수면무호흡이 생기면 병원 상담이 필요해요.\n\n아기들은 엄마의 감정에 반응해요. 아빠는 오늘 하루, 아내가 편안히 쉴 수 있도록 따뜻한 말 한마디를 건네보세요.🍀"
    },
    20: {
      subtext: "[20주차] 두 아이와 함께 반환점을 지났어요\n\n자궁이 커지며 다리 부종과 하지정맥류가 생길 수 있어요. 자세 바꾸기, 다리 올리기, 압박스타킹이 도움돼요.\n\n정밀 초음파로 두 아이의 얼굴을 확인하는 시기! 함께 웃고, 기록하며 특별한 순간을 나눠보세요.🩷"
    },
    21: {
      subtext: "[21주차] 숨이 차고 배가 뭉쳐요.\n\n자궁이 커지며 폐를 눌러 숨이 차고, 불규칙한 배뭉침도 느껴질 수 있어요. 무리한 활동은 피하고, 자주 쉬어주세요.\n\n🍀임신 중 불안한 감정은 누구나 겪는 자연스러운 일이에요. 남편의 따뜻한 말 한마디가 큰 힘이 됩니다. \"잘하고 있어💗\" 한마디로 마음을 나눠주세요."
    },
    22: {
      subtext: "[22주차] 몸의 균형 잡기가 더 어려워졌어요!\n\n쌍둥이를 품은 몸은 무게중심이 더 빠르게 바뀌고 요통도 심해지기 쉬워요. 넘어지지 않도록 천천히 움직이고, 평평한 신발을 신어주세요.\n\n혹시 넘어졌다면 통증이나 배뭉침이 있는지 꼭 체크!\n\n두 아기를 지키는 가장 든든한 움직임은 조심스러움이에요.😊"
    },
    23: {
      subtext: "[23주차] 임신 중 치질과 가려움, 흔한 변화예요.\n\n변비로 인해 치질이 생기기 쉬운 시기예요. 섬유질과 수분 섭취, 좌욕이 도움돼요.\n\n짧은 태교여행도 정서에 큰 도움이 된답니다. 무리 없는 외출로 기분 전환해보세요.🤗"
    },
    24: {
      subtext: "[24주차] 무거워진 몸, 섬세한 관리가 필요해요.\n\n이제 임신성 당뇨 검사 시기예요. 체중 조절과 건강한 식단, 주기적인 운동으로 임신성 당뇨를 예방하세요.👟\n\n다리에 쥐도 나고 잇몸 출혈도 나타나는 등, 몸이 불편해진 엄마에게 아빠의 작은 손길이 큰 위로가 되는 시기입니다."
    },
    25: {
      subtext: "[25주차] 더 무거워진 몸, 더 깊어진 교감\n\n자궁과 양수가 빠르게 늘어나 숨차고 소화도 더뎌질 수 있어요.\n\n이제 두 아기는 엄마 아빠 목소리에 반응하며 감정을 느끼기 시작해요.\n태명을 부르고, 말을 건네며 매일 따뜻한 교감을 나눠보세요.💕"
    },
    26: {
      subtext: "[26주차] 더 무거워진 배, 깊어진 감정 교감\n\n배가 무거워 갈비뼈와 아랫배 통증이 생기고, 균형 잡기도 어려워요.\n\n엄마의 감정에 쌍둥이도 함께 반응하니, 마음을 안정시키고 긍정적인 생각을 많이 하세요.🌸\n\n아빠는 출산 경로와 입원 준비물을 미리 체크해 두면 좋아요."
    },
    27: {
      subtext: "[27주차] 다리 붓기와 임신중독증, 잘 살펴야 해요.\n\n쌍둥이를 품은 몸은 부종·쥐 등 증상이 더 잦아요. 두통·급격한 체중 증가 등은 임신중독증 신호일 수 있어요.\n\n아기들은 숨쉬기·눈뜨기 연습 중!\n아빠는 로션이나 오일을 발라서 아내의 종아리를 가볍게 마사지해 주세요.🌼"
    },
    28: {
      subtext: "[28주차] 임신 후기 시작! 출산 대비 계획을 세워봐요.\n\n유방에서 초유가 만들어지기 시작하고, 빠르면 초유가 흘러나올 수도 있어요.\n\n임신 중 건망증은 자연스러운 현상이니 너무 스트레스 받지 마세요. 모든 걸 혼자 해결하려 하지 않아도 괜찮아요.🙂"
    },
    29: {
      subtext: "[29주차] 검진 간격이 짧아졌어요! 출산 준비, 이제 시작해요.\n\n이제부터는 2주마다 정기검진을 받아요. 태동이 강해지며 갈비뼈 통증도 느껴지고, 분비물 증가로 외음부 가려움이 생기기도 해요.😣\n\n👨🏻아빠도 검진에 함께하며 출산 교실 참여 등 본격적인 출산 준비를 시작해보세요."
    },
    30: {
      subtext: "[30주차] 점점 더 무거워지는 몸, 차근차근 준비해요.\n\n자궁이 명치까지 올라와 숨이 차고 속이 쓰릴 수 있어요. 가벼운 걷기나 임산부 요가는 체력 유지에 도움돼요.\n\n출산일은 예상보다 빨리 올 수 있으니 입원 가방과 산후 준비물을 하나씩 챙겨보세요.\n\n아빠는 출산 서류, 육아휴직 계획, 병원비 예산 등 실무 준비를 맡아주세요!🧾"
    },
    31: {
      subtext: "[31주차] 몸의 무게만큼 마음도 무거운 시기, 다정하게 돌봐주세요.\n\n쌍둥이로 인해 요통·어깨 결림, 요실금, 정맥류 등이 심해져요. 가벼운 운동과 마사지, 케겔운동, 체중 관리로 완화해보세요.\n\n산후조리 방법은 부부가 함께 상의하고, 두 아이를 위한 공간도 차근히 준비해보세요. 아빠의 관심과 참여는 무엇보다 큰 힘이 됩니다!💖"
    },
    32: {
      subtext: "[32주차] 쌍둥이를 품은 지금, 몸과 마음 모두 따뜻하게 돌봐주세요.\n\n관절이 뚝뚝, 배가 무겁고 일상도 불편해졌어요. 지금은 수분과 영양 보충, 부드러운 운동, 안전한 자세가 중요한 때예요. 태동 체크와 모유수유 준비도 차근차근 해보세요.\n\n아빠는 체력을 관리하고 아기들 공간 준비를 함께 해주세요.😊"
    },
    33: {
      subtext: "[33주차] 출산 준비, 이제는 실전이에요!\n\n다리에 쥐가 나고 골반이 당기면 무리한 활동은 잠시 멈춰주세요. 출산 가방은 지금 미리 챙겨두는 게 좋아요.\n\n분만호흡법 연습도 시작해요. 아빠는 아내에게 소화 잘 되는 식사를 챙겨주고, 본인 짐도 미리 체크해두세요."
    },
    34: {
      subtext: "[34주차]  출산준비로 바쁘다 바빠!\n\n쌍둥이를 위한 출산 준비, 이제 실전이에요. 분만호흡법 연습과 긍정적인 마음 다지기로 긴장을 풀어보세요.\n\n아기들은 신생아처럼 자라 공간도 거의 꽉 찼답니다.\n\n아빠도 출산휴가 신청, 병원 이동 경로 미리 점검해두세요."
    },
    35: {
      subtext: "[35주차] 분만호흡법을 연습해요.\n\n분만 시 산소 공급과 통증 완화에 도움 되는 호흡법을 지금부터 미리 연습해두세요.\n\n출산에 대한 두려움은 자연스러운 감정이에요.\n\n😣 스스로를 믿고, 너무 스트레스받지 않도록 긍정적으로 생각해 봐요."
    },
    36: {
      subtext: "[36주차] 막달, 결승선을 향해 가고 있어요!\n\n배가 아래로 당기는 느낌이 들고, 몸무게는 최고치에 가까워졌어요.\n\n아기는 지금 태어나도 대부분 안전하지만, 폐 성숙을 위해 조금만 더 기다려요.\n\n아빠는 출산 임박을 주변에 알리고 갑작스런 상황에 대비해주세요. 마지막 한 달, 함께 차분히 준비해봐요.🙂"
    },
    37: {
      subtext: "[37주차] 이제부터는 조산이 아니에요!\n\n언제든 출산이 시작될 수 있어요. 배가 불규칙하게 당기고 점액 분비도 늘어나요. 정기검진으로 자궁경부 상태를 확인해요.\n\n아빠는 아내 곁을 지켜주고, 외출 시에도 연락 가능한 상태를 유지해주세요. 이제 만날 준비, 정말 끝났어요!🤗"
    },
    38: {
      subtext: "[38주차] 긴장을 늦출 수 없는 한 주!\n\n출산가방에 빠진 물건이 없는지 다시 점검해요. 진통 간격 5분, 강한 진통, 양수 파수나 출혈 시 즉시 병원에 가야합니다.\n\n아빠는 불안한 아내에게 큰 힘이 되는 말을 해주세요.\n\"걱정 마, 내가 옆에 있어!🫶🏻\""
    },
    39: {
      subtext: "[39주차] 아기 만날 준비 완료! 마지막 점검만 남았어요.\n\n규칙적인 자궁 수축·이슬·양막 파열은 출산 신호예요.\n\n진통 간격이 짧아지거나 출혈·양수 흐름이 있으면 즉시 병원으로!🚑\n\n곧 아기를 만날 순간이에요. 막판 스퍼트, 아빠도 화이팅!"
    },
    40: {
      subtext: "[40주차] 드디어 만남의 순간!\n\n10개월 여정의 끝이 보이네요. 진통이 규칙적이고 강해지면 병원으로 가세요. 초산인 경우에는 진통이 조금 늦을 수도 있어요.\n\n아빠는 진통 주기 체크와 아내 곁 지키기, 출산 후 아내 상태까지 꼭 살펴주세요.\n\n엄마 아빠 아가 모두, 정말 수고 많았어요!🍀"
    }
  };
  
  export default twinsBabyCongratsData;